import { render, staticRenderFns } from "./vIngredientsDisplayNames.vue?vue&type=template&id=5270d93a&scoped=true"
import script from "./vIngredientsDisplayNames.vue?vue&type=script&lang=ts"
export * from "./vIngredientsDisplayNames.vue?vue&type=script&lang=ts"
import style0 from "./vIngredientsDisplayNames.vue?vue&type=style&index=0&id=5270d93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270d93a",
  null
  
)

export default component.exports